export const processArguments = (...args: any) => {
    return args.filter((arg: any) => arg !== null && arg !== undefined).join('-');
  }